import { EcpServices } from '../../ecp-locator';

export const getConfirmTitle = (service?: EcpServices): string => {
  switch (service) {
    case EcpServices.aec:
      return 'appointmentRegistration.appointmentCheckStep.title.aec';
    case EcpServices.cv:
      return 'appointmentRegistration.appointmentCheckStep.title.cv';
    default:
      return 'appointmentRegistration.appointmentCheckStep.title';
  }
};
